import { FilterAdapter, useUrlFilterController } from 'app/components/filters/url-filters';
import { ExtendedOffersResponse } from 'app/console-api/offers/offers-extended';
import Select from 'react-select';
import { StatisticsFiltersStyles } from 'app/components/common/common-styles';

type OfferOption = {
  id: string;
  value: string;
  label: string;
};

export const OfferListFilterAdapter: FilterAdapter<string[]> = {
  key: 'offers',
  fromUrl: (sp) => {
    const raw = sp.get('offers');
    if (!raw) return null;
    const arr = raw
      .split(',')
      .map((s) => s.trim())
      .filter((s) => s.length > 0);
    return arr.length ? arr : null;
  },
  toUrl: (sp, value) => {
    const next = new URLSearchParams(sp.toString());
    if (!value || value.length === 0) {
      next.delete('offers');
    } else {
      next.set('offers', value.join(','));
    }
    return next;
  },
  toKey: (v) => `offers:${v && v.length ? [...v].sort().join(',') : 'all'}`
};

type OfferListFilterProps = {
  offers: ExtendedOffersResponse[];
} & Record<string, any>;

export const OfferListFilter = ({ offers, props }: OfferListFilterProps) => {
  const ctl = useUrlFilterController();
  const value = ctl.get(OfferListFilterAdapter) ?? []; // string[] of selected offer IDs
  const options: OfferOption[] = offers.map((offer) => ({
    id: offer.offer.id,
    value: offer.offer.id,
    label: offer.offer.name
  }));

  // react-select multi expects an array of option objects
  const selected = options.filter((o) => value.includes(o.value));

  return (
    <Select<OfferOption, true>
      styles={StatisticsFiltersStyles()}
      {...props}
      isMulti
      closeMenuOnSelect={false}
      options={options}
      hideSelectedOptions={false}
      value={selected}
      placeholder={'All Offers'}
      onChange={(opts: any) => {
        const selectedOfferIds = opts ? opts.map((o: any) => o.value) : [];
        ctl.set(OfferListFilterAdapter, selectedOfferIds.length ? selectedOfferIds : null);
      }}
    />
  );
};
